<div *ngIf="response.violatedRules?.length === 1 && response.violatedRules[0].exception; then expandable else regular"></div>

<ng-template #regular>
	<cp-popup class="disable-popup-backround"
			  [label]="'InternalError'"
			  [contentPadding]="false"
			  [resizable]="false"
			  [disposable]="false"
			  [width]="'720px'"
			  [autoHeight]="true"
			  (close)="onClose()">
		<div class="popup-container">
			<div *ngFor="let clinicalRule of response.violatedRules">
				<div class="message-container">
					<div class="icon">
						<i class="cp-icon-error"></i>
					</div>
					<div class="message">
						<!-- ideally i would use cp-clinical-response-message but it is in the RISCommonModule and i dont want to depend on it -->
						<ng-container *ngIf="clinicalRule.translationNeeded else noTranslation">
							{{ clinicalRule.message | cpMessageTranslate:clinicalRule.messageParameters }}
						</ng-container>
						<ng-template #noTranslation>
							{{ clinicalRule.message }}
						</ng-template>
					</div>
					<hr/>
				</div>
			</div>
		</div>
	</cp-popup>
</ng-template>

<ng-template #expandable>
	<cp-popup [label]="'InternalError'"
			  [contentPadding]="false"
			  [resizable]="false"
			  [disposable]="false"
			  [width]="'720px'"
			  [autoHeight]="true"
			  [autoHeightAutoReCalc]="true"
			  (close)="onClose()">
		<div class="popup-container">
			<div class="message-container">
				<div class="icon">
					<i class="cp-icon-error"></i>
				</div>
				<div class="message">
					<!-- ideally i would use cp-clinical-response-message but it is in the RISCommonModule and i dont want to depend on it -->
					<ng-container *ngIf="response.violatedRules[0].translationNeeded else noTranslation2">
						{{ response.violatedRules[0].message | cpMessageTranslate:response.violatedRules[0].messageParameters }}
					</ng-container>
					<ng-template #noTranslation2>
						{{ response.violatedRules[0].message }}
					</ng-template>
				</div>
			</div>

			<div class="exception-container" *ngIf="showException">
				{{ response.violatedRules[0].exception }}
			</div>

			<div class="actions-container">
				<ng-content select=".expandable-error-buttons"></ng-content>
			</div>
		</div>
	</cp-popup>
</ng-template>
